import { useState, useEffect } from 'react';

// debounce hook to delay function call
export default function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value]);

    return debouncedValue;
}



// WEBPACK FOOTER //
// ./app/helpers/useDebounce.js